<div class="app-habitation-v2" [appDynamicBackgroundImage]="getBackgroundImageSource()">
  <div class="side-container fade-in-right">
    <h1 class="titre-page fade-in-right-short" [innerHTML]="'page-non-authentifie.titre' | translate"></h1>
    <p class="paragraph fade-in-right-delay-brief" [innerHTML]="'page-non-authentifie.texte' | translate"></p>
    <p
      class="paragraph fade-in-right-delay-brief"
      [innerHTML]="
        'page-non-authentifie.texte-clicktocall'
          | translate: { numeroMontreal: telephoneMontreal, numeroSansFrais: telephoneSansFrais }
      "
    ></p>

    <div class="btn-container fade-in-right-delay-long">
      <app-boite-contact></app-boite-contact>
    </div>
  </div>
</div>
